import classNames from "classnames";

const Slider = ({ value, marks, options, onClick }) => {
  return (
    <div className="mutualMobility-slider__wrapper">
      {marks.map((mark, index) => (
        <div
          onClick={() => onClick(mark)}
          className={classNames({ active: mark === value })}
          key={`option-${index}`}
        >
          {options[mark]}
        </div>
      ))}
    </div>
  );
};

export default Slider;
